import React from 'react';
import { useAppUser } from '@bechtel/client-common';
import { AuthPermission, AuthScope } from '@bechtel/types';

export interface DashboardPermissions {
  canViewSuperIntendentDashboard: boolean;
  canViewForemanDashboard: boolean;
  canViewSuperAdminDashboard: boolean;
  canViewFieldEngineerDashboard: boolean;
  canViewOtherUserDashboard: boolean;
  hasNoDefaultDashboard: boolean;
}

export function useDashboardPermissions(): DashboardPermissions {
  const { hasPermissionScope } = useAppUser();

  const dashboardPermissions = React.useMemo(() => {
    const canViewSuperIntendentDashboard = hasPermissionScope({
      permission: AuthPermission.VIEW_DEFAULT_DASHBOARD,
      scope: AuthScope.SUPERINTENDENT,
    });
    const canViewForemanDashboard = hasPermissionScope({
      permission: AuthPermission.VIEW_DEFAULT_DASHBOARD,
      scope: AuthScope.FOREMAN,
    });
    const canViewSuperAdminDashboard = hasPermissionScope({
      permission: AuthPermission.VIEW_DEFAULT_DASHBOARD,
      scope: AuthScope.SUPER_ADMIN,
    });
    const canViewFieldEngineerDashboard = hasPermissionScope({
      permission: AuthPermission.VIEW_DEFAULT_DASHBOARD,
      scope: AuthScope.FIELD_ENGINEER,
    });
    const canViewFieldWeldEngineerDashboard = hasPermissionScope({
      permission: AuthPermission.VIEW_DEFAULT_DASHBOARD,
      scope: AuthScope.FIELD_WELD_ENGINEER,
    });
    const canViewOtherUserDashboard = hasPermissionScope({
      permission: AuthPermission.VIEW_OTHER_USER_DASHBOARD,
      scope: AuthScope.YES,
    });
    const canViewDownloadWeeklyWorkList = hasPermissionScope({
      permission: AuthPermission.DOWNLOAD_WEEKLY_WORK_LIST,
      scope: AuthScope.YES,
    });
    const canViewAllCrewsStats = hasPermissionScope({
      permission: AuthPermission.VIEW_ALL_CREWS_STATS,
      scope: AuthScope.YES,
    });
    const hasNoDefaultDashboard =
      !canViewSuperIntendentDashboard &&
      !canViewForemanDashboard &&
      !canViewFieldEngineerDashboard &&
      !canViewSuperAdminDashboard &&
      !canViewFieldWeldEngineerDashboard;
    return {
      canViewSuperIntendentDashboard,
      canViewForemanDashboard,
      canViewSuperAdminDashboard,
      canViewFieldEngineerDashboard,
      canViewOtherUserDashboard,
      hasNoDefaultDashboard,
      canViewFieldWeldEngineerDashboard,
      canViewDownloadWeeklyWorkList,
      canViewAllCrewsStats,
    };
  }, [hasPermissionScope]);
  return dashboardPermissions;
}
